import { supabase } from '../lib/supabase';

export interface ActivityLog {
  user_id: string;
  action: string;
  entity_type: string;
  entity_id?: string;
  details?: any;
}

export async function logActivity(activity: ActivityLog) {
  try {
    // Si c'est une réservation, récupérer les informations du logement
    if (activity.entity_type === 'booking' && activity.details?.property_id) {
      const { data: property } = await supabase
        .from('properties')
        .select('id, name')
        .eq('id', activity.details.property_id)
        .single();

      if (property) {
        activity.details.property = property;
      }
    }

    const { error } = await supabase
      .from('activity_logs')
      .insert([{
        ...activity,
        created_at: new Date().toISOString()
      }]);

    if (error) throw error;
  } catch (error) {
    console.error('Error logging activity:', error);
  }
}

export async function getActivityLogs(filters?: {
  user_id?: string;
  entity_type?: string;
  entity_id?: string;
  start_date?: Date;
  end_date?: Date;
}) {
  let query = supabase
    .from('activity_logs')
    .select(`
      id,
      user_id,
      action,
      entity_type,
      entity_id,
      details,
      created_at,
      users:user_id (first_name, last_name)
    `)
    .order('created_at', { ascending: false });

  if (filters) {
    if (filters.user_id) {
      query = query.eq('user_id', filters.user_id);
    }
    if (filters.entity_type) {
      query = query.eq('entity_type', filters.entity_type);
    }
    if (filters.entity_id) {
      query = query.eq('entity_id', filters.entity_id);
    }
    if (filters.start_date) {
      query = query.gte('created_at', filters.start_date.toISOString());
    }
    if (filters.end_date) {
      query = query.lte('created_at', filters.end_date.toISOString());
    }
  }

  const { data, error } = await query;
  if (error) throw error;
  return data;
}